import React from "react";
import CalendarTab from "./CalendarTab";
import CalendarMain from "./CalendarMain";

export default function Calendar() {
  return (
    <div className="w-full p-2 pt-6 px-6 ">
      <CalendarMain />
    </div>
  );
}
